<template>
  <div id="rechargeB">
    <div class="header">
      <div><span>接入号：</span>>{{ this.$store.state.recordLoginText }}</div>
      <div><span>ICCID号：</span>>{{ this.$store.state.recordLoginText }}</div>
      <div>
        <span>运营商：{{ this.simInfo.supplierTypeName }}</span>
      </div>
    </div>
    <div class="packagePanel">
      <h1 class="package-title">选择流量包</h1>
      <div
        class="package"
        v-for="item in simData"
        :key="item.id"
        @click="changeState(item)"
      >
        <span
          class="label-defined"
          :class="{ 'label-defined-active': indexActive == item.id }"
        >
          <label><van-icon name="success" color="#fff" /></label>
        </span>

        <div
          class="package-name"
          :class="{ 'overlay-package': item.type == 11 }"
        >
          <h1 style="color: #07c160" v-if="item.type == 11">
            {{ item.packageName ? item.packageName : item.name }}
          </h1>
          <h1 v-else>{{ item.packageName ? item.packageName : item.name }}</h1>

          <!-- 生效时间 -->   
          <p if="item.type == 18 || item.packageTypeCode == 18">
            有效期：{{dateFormat('yyyy-MM-dd', new Date())}} 至 {{afterManyDays(item.type==18?730:item.type==8?180:item.type==9?365:30)}}
          </p>
          
        </div>

        <div
          class="package-price"
          :class="{ 'overlay-package': item.type == 11 }"
        >
          <p>优惠价</p>
          <p>
            {{ item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100 }}元
          </p>
        </div>
      </div>
    </div>
    <div class="packagePanel">
      <h1 class="package-title">当前已订购套餐</h1>
      <h3 v-show="!simInfo.simPackageList[0]" style="color: red">未订购套餐</h3>
      <div
        class="package"
        v-for="item in simInfo.simPackageList"
        :key="item.id">
        <span
          class="label-defined"
          :class="{ 'label-defined-active': indexActive == item.id }"
        >
          <label><van-icon name="loading" color="#07c160" /></label>
        </span>
        <div
          class="package-name"
          :class="{ 'overlay-package': item.type == 11 }"
        >
          <h1 >{{ item.packageName ? item.packageName : item.name }}</h1>
          <!-- 生效时间 -->
          <p style="color: #07c160">
            生效时间：{{ item.startTime }} 
          </p>
          <p style="color: #07c160">
            过期时间：{{ item.endTime }} 
          </p>
        </div>

      </div>
      <!-- <ul>
                <li v-for="item in simInfo.simPackageList" :key="item.id">
                    <p> {{ item.packageName }}</p>
                    <div>
                        <p>生效时间： {{ item.startTime }}</p>
                        <p v-if="new Date(getDateByTimeStr(item.endTime)[0],getDateByTimeStr(item.endTime)[1],getDateByTimeStr(item.endTime)[2],getDateByTimeStr(item.endTime)[3],getDateByTimeStr(item.endTime)[4],getDateByTimeStr(item.endTime)[5]) < new Date()" style="color: red;">过期时间： {{ item.endTime }}</p>
                        <p v-else>过期时间： {{ item.endTime }}</p>
                    </div>
                </li>
            </ul> -->
    </div>

    <Checkstand
      :checkstandStyle="checkstandStyle"
      :dataToPay="dataToPay"
      :price="price"
      :type="type"
      :packageTypeCode="packageTypeCode"
    />

    <div class="toRecharge">
      <div class="toRecharge-top" v-if="showMonthChoose || isNaturalMonth">
        <van-radio-group v-model="isNextMonth" class="radio-group-defined">
          <div>
            <van-radio name="0" checked-color="#FFA941">本月生效</van-radio>
          </div>
          <div>
            <van-radio name="1" checked-color="#FFA941">次月生效</van-radio>
          </div>
        </van-radio-group>
      </div>

      <p class="detail" v-if="isNaturalMonth" style="color: red">
        请在有效时间内使用
        <span v-show="this.isNextMonth == 0"
          >，<span style="color: red">月底清零。</span></span
        >
        <span v-show="this.isNextMonth == 1"
          >，<span style="color: red">次月月底清零。</span></span
        >
      </p>

      <div class="toRecharge-bottom">
        <p>
          金额：<span>{{ money_format(price, 2, ".", ",") }} 元</span>
        </p>
        <div class="toRechargeBtn" @click="toRecharge()">订 购</div>
      </div>
    </div>
  </div>
</template>
<script>
import { wxRequest } from "@/api/user.js";

import Checkstand from "@/components/Checkstand";

export default {
  components: { Checkstand },
  data() {
    return {
      indexActive: "",
      simData: [],

      itemInfo: {
        supplierTypeName: "",
        flowRate: "",
        salePriceRmb: "",
      },
      simInfo: {
        simId: "",
        simPackageList: [],
        supplierTypeCode: "",
        packageName: null,
        endTime: null,
        iccid:null,
        intoNo:null,
        supplierTypeName:null
      },
      isAdmin: "",
      globalIsAdmin: "",
      isNextMonth: "0",
      payType: 1,
      isNaturalMonth: false,
      showCheckstand: false,
      showMonthChoose: false, //判断是否显示本月次月

      //收银台
      checkstandStyle: {
        height: "50%",
        transition: "0.8s !important",
      },
      dataToPay: {},
      price: 0,
      packageTypeCode: 0,
      type: "",
      mobile: "",
      iccid: "",
      code: "",
      showAds: true,
      gzh: "",
    };
  },
  methods: {
    getDateByTimeStr(timeStr) {
      if (timeStr && typeof timeStr === "string") {
        let dayStr = timeStr.split(" ")[0].split("-");
        let hourStr = timeStr.split(" ")[1].split(":");
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(
        (res) => {
          if (res.data.code == 200) {
            let result = res.data.data;
            localStorage.setItem("supplierCode", result.supplierCode);
            localStorage.setItem("supplierName", result.supplierName);
            localStorage.setItem("supplierTypeCode", result.supplierTypeCode);
            this.simInfo = result;
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
          }
        }
      );
    },

    logoutHandler() {
      localStorage.removeItem("iccid");
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == "true") {
        window.location.href = window.location.origin + "/";
      }
      //若为代理商微信公众号
      else {
        window.location.href =
          window.location.origin + "/?source=" + localStorage.getItem("appid");
      }
    },

    changeState(item) {
      this.indexActive = item.id;
      this.itemInfo = item;
      this.price = item.salePriceRmb ? item.salePriceRmb : item.salePrice / 100;
      this.type = item.type;
      this.packageTypeCode = item.packageTypeCode;

      if (
        item.isAdmin != null &&
        item.isAdmin != undefined &&
        item.isAdmin == 1
      ) {
        this.isAdmin = item.isAdmin;
      } else {
        this.isAdmin = this.globalIsAdmin;
      }

      this.isNaturalMonth = item.type == 2 || item.type == 10 ? true : false;
      this.showMonthChoose = item.type == 2 ? true : false;
    },

    toRecharge() {
      let self = this;
      //如果是青岛联通，//直接跳去换卡链接
      console.info(
        "self.$store.state.supplierCode",
        self.$store.state.supplierCode
      );
      if (
        self.$store.state.supplierCode == "47D2E3C5A85845F7800DFD52DFB06CE4"
      ) {
        this.$router.push({
          path: "/user/userChgCard",
          query: {
            iccid: self.$store.state.iccid,
          },
        });
        return;
      }

      var data = {
        iccid: this.$store.state.iccid,
        soldPackageId: this.itemInfo.id,
        isAdmin: this.isAdmin,
        salePriceRmb: this.itemInfo.salePriceRmb,
        mobile: this.mobile,
      };
      //判断是否是月卡
      if (this.isNaturalMonth) {
        data.isNextMonth = this.isNextMonth;
      } else {
        data.isNextMonth = "0"; //万能卡
      }

      if (this.$store.state.source != false) {
        data.source = this.$store.state.source;
      } else {
        data.source = "xxgzh";
      }

      this.$store.state.showCheckstand = true;
      this.$store.state.showCheckstandSource = "flowRecharge";
      this.dataToPay = data;
    },

    //第n天后
    afterManyDays(manyDays) {
      let startTime = new Date();
      let startDate = new Date(startTime);
      startDate.setDate(startDate.getDate() + manyDays);
      return this.dateFormat("yyyy-MM-dd", startDate);
    },

    // 本月最后一天
    lastDayOfThisMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return this.dateFormat("yyyy-MM-dd", new Date(year, month + 1, 0));
    },

    //下个月第一天
    firstDayOfNextMonth() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth();
      var day = date.getDate();

      let date2 = new Date(year, month + 1, 1);
      return this.dateFormat("yyyy-MM-dd", new Date(date2));
    },
    // 下个月最后一天
    lastDayOfNextMonth() {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      return this.dateFormat("yyyy-MM-dd", new Date(year, month + 2, 0));
    },
    //获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    changePayType(type) {
      this.payType = type;
    },
  },
  created() {
    var source = this.getQueryVariable("source")
      ? this.getQueryVariable("source")
      : process.env.VUE_APP_APPID;
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source ? source : process.env.VUE_APP_APPID;
    console.log(appid);
    // iccid
    this.iccid = this.$route.query.iccid;
    console.log(this.iccid);
    if (this.iccid == "" || this.iccid == null) {
      this.$dialog.alert({
        title: "提示",
        message: "查询不到卡号，请关注【小象通信】公众号进行充值",
      });
      return;
    }
    localStorage.setItem("iccid", this.iccid);

    var redirectUrl = window.location.href;
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
    }
    console.log(this.code);
    var data = {
      requestId: this.iccid,
      code: this.code,
      iccid: this.iccid,
    };
    //绑定数据
    wxRequest("sim/bindIccid", data, "get").then((res) => {
      if (result.data.code != 200) {
        this.$dialog.alert({ title: "提示", message: "请重新扫码登录！" });
        return;
      }
    });
    wxRequest("sim/detail", { iccid: this.iccid }, "post").then((res) => {
      if (res.data.code == 200) {
        this.simInfo = res.data.data;
      } else {
        this.$dialog.alert({ title: "提示", message: res.data.message });
      }
    });
    wxRequest("sim/user/soldPkg", data, "get").then((res) => {
      var result = res.data.data;
      if (res.data.code == 200 && result.list.length > 0) {
        let resultArray = [];
        for (let i = 0; i < result.list.length; i++) {
          if (result.list[i].type == 11) {
            resultArray.push(result.list[i]);
          } else {
            resultArray.unshift(result.list[i]);
          }
        }

        this.simData = resultArray;
        this.isAdmin = result.isAdmin;
        this.globalIsAdmin = result.isAdmin;
        this.itemInfo = this.simData[0];
        // console.log('1',this.itemInfo)
        this.indexActive = this.simData[0].id;
        this.isNaturalMonth = this.simData[0].type == 2 ? true : false;
        this.price = this.simData[0].salePriceRmb
          ? this.simData[0].salePriceRmb
          : this.simData[0].salePrice / 100;
        console.log(this.price);
      }
    });

    /**每月倒数第6天默认选中次月生效**/
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();

    var date2 = new Date(year, month + 1, 0);
    var endDay = date2.getDate();
    day >= endDay - 8 ? (this.isNextMonth = "1") : (this.isNextMonth = "0");
  },

  mounted() {
    let param = {
      iccid: this.iccid,
      mobile: localStorage.getItem("mobile"),
    };
    wxRequest("sysUser/account/querySysUserAccount", param, "post").then(
      (res) => {
        if (res.data.code == 200) {
          this.mobile = res.data.data.mobile;
        }
      }
    );
  },
};
</script>
<style lang="less">
#rechargeB {
  background: #f5f5f5;
  height: 100%;

  .header {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 10px;

    div {
      color: #999;
      font-size: 15px;
      line-height: 30px;
    }
    div:nth-child(2) {
      color: #333;
      font-size: 18px;
    }
  }

  .packagePanel {
    padding: 5px 16px;
    background: #fff;
    border-bottom: 90px solid #f5f5f5;

    .package-title {
      padding: 10px 0;
      color: #333;
      font-weight: bold;
    }

    .package {
      display: flex;
      position: relative;
      margin-bottom: 20px;

      .label-defined {
        display: block;
        border-width: 14px 18px 14px 18px;
        border-style: solid;
        border-color: transparent;
        position: absolute;

        label {
          position: absolute;
          left: -14px;
          top: -12px;
          background: transparent;
        }
      }

      .label-defined-active {
        border-color: red transparent transparent red;
      }

      .package-name {
        flex-grow: 1;
        padding: 5px 0 5px 20px;
        border: 1px dashed #ffa941;

        h1 {
          margin: 5px 0;
          color: #ffa941;
          font-size: 18px;
        }

        p {
          margin: 10px 0;
          color: #333;
          font-size: 14px;
        }
      }

      .package-name.overlay-package {
        border-color: #07c160;
      }

      .package-price {
        flex-grow: 0;
        width: 80px;
        border: 1px solid #ffa941;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
          margin: 5px 0;
          color: #fff;
        }
        p:last-child {
          font-size: 18px;
        }

        background: #ffa941;
      }

      .package-price.overlay-package {
        border-color: #07c160;
        background: #07c160;
      }
    }
  }

  .toRecharge {
    position: fixed;
    width: 100%;
    bottom: 0;
    font-size: 16px;

    .toRecharge-top {
      background: #f5f5f5;
      display: flex;

      .radio-group-defined {
        display: flex;
        padding-left: 20px;
        justify-content: center;
        align-items: center;
        height: 40px;

        div {
          height: 20px;
          margin-right: 15px;
        }
      }
    }

    .detail {
      color: #a0a0a0;
      background: #f5f5f5;
      padding-left: 20px;
      padding-bottom: 5px;
    }

    .toRecharge-bottom {
      display: flex;
      p {
        padding-right: 15px;
        flex-grow: 1;
        color: #333333;
        background: #fff;
        text-align: right;
        line-height: 45px;

        span {
          color: #ffa941;
        }
      }

      .toRechargeBtn {
        padding: 0 30px;
        display: inline-block;
        line-height: 45px;
        flex-grow: 0;
        color: #fff;
        background: #ffa941;
      }
    }
  }
}
</style>
